/**
 * Default layer tree shared by Mapview and Construction.
 * Group -> children (layer key -> { name, visible, wmsLayer }).
 * Always clone via createLayerGroups() before putting it in React state.
 */
const DEFAULT_LAYER_GROUPS = {
  Boundary: {
    name: "Boundary",
    visible: true,
    expanded: false,
    children: {
      ga: {
        name: "GA Boundary",
        visible: true,
        wmsLayer: "haryanagas:ga",
      },
      ca: {
        name: "CA Boundary",
        visible: true,
        wmsLayer: "haryanagas:ca",
      },
      cngboundary: {
        name: "CNG Boundary",
        visible: true,
        wmsLayer: "haryanagas:cngboundary",
      },
    },
  },

  CNG: {
    name: "CNG Infrastructure",
    visible: true,
    expanded: false,
    children: {
      cng: {
        name: "CNG Stations",
        visible: true,
        wmsLayer: "haryanagas:cng",
      },
      compressor: {
        name: "Compressors",
        visible: true,
        wmsLayer: "haryanagas:compressor",
      },
      cascade: {
        name: "CNG Cascades",
        visible: true,
        wmsLayer: "haryanagas:cascade",
      },
      dispenser: {
        name: "CNG Dispensers",
        visible: true,
        wmsLayer: "haryanagas:dispenser",
      },
    },
  },

  PressureStations: {
    name: "Pressure Stations",
    visible: true,
    expanded: false,
    children: {
      cgs: {
        name: "CGS",
        visible: true,
        wmsLayer: "haryanagas:cgs",
      },
      drs: {
        name: "DRS",
        visible: true,
        wmsLayer: "haryanagas:drs",
      },
      sr: {
        name: "SR",
        visible: true,
        wmsLayer: "haryanagas:sr",
      },
      mdpe_sr: {
        name: "MDPE SR",
        visible: true,
        wmsLayer: "haryanagas:mdpe_sr",
      },
    },
  },

  Pipelines: {
    name: "Pipelines",
    visible: true,
    expanded: false,
    children: {
      steel_pipeline: {
        name: "Steel Pipeline",
        visible: true,
        wmsLayer: "haryanagas:steel_pipeline",
      },
      mdpe_pipeline: {
        name: "MDPE Pipeline",
        visible: true,
        wmsLayer: "haryanagas:mdpe_pipeline",
      },
    },
  },

  Valves: {
    name: "Valves",
    visible: true,
    expanded: false,
    children: {
      steel_valve: {
        name: "Steel Valve",
        visible: true,
        wmsLayer: "haryanagas:steel_valve",
      },
      mdpe_valve: {
        name: "MDPE Valve",
        visible: true,
        wmsLayer: "haryanagas:mdpe_valve",
      },
    },
  },

  PipelineMarkers: {
    name: "Pipeline Markers",
    visible: true,
    expanded: false,
    children: {
      steel_markers: {
        name: "Steel Marker",
        visible: true,
        wmsLayer: "haryanagas:steel_markers",
      },
      mdpe_marker: {
        name: "MDPE Marker",
        visible: true,
        wmsLayer: "haryanagas:mdpe_marker",
      },
    },
  },

  BurialDepth: {
    name: "Burial Depth",
    visible: false,
    expanded: false,
    children: {
      steel_depth: {
        name: "Steel Depth",
        visible: false,
        wmsLayer: "haryanagas:steel_depth",
      },
      mdpe_depth: {
        name: "MDPE Depth",
        visible: false,
        wmsLayer: "haryanagas:mdpe_depth",
      },
    },
  },

  OffsetPoints: {
    name: "Offset Points",
    visible: false,
    expanded: false,
    children: {
      steel_offset: {
        name: "Steel Offset",
        visible: false,
        wmsLayer: "haryanagas:steel_offset",
      },
      mdpe_offset: {
        name: "MDPE Offset",
        visible: false,
        wmsLayer: "haryanagas:mdpe_offset",
      },
    },
  },

  PipelineFittings: {
    name: "Pipeline Fittings",
    visible: false,
    expanded: false,
    children: {
      steel_ncfitting: {
        name: "Steel Fitting",
        visible: false,
        wmsLayer: "haryanagas:steel_ncfitting",
      },
      mdpe_ncfitting: {
        name: "MDPE Fitting",
        visible: false,
        wmsLayer: "haryanagas:mdpe_ncfitting",
      },
    },
  },

  CrossingLocations: {
    name: "Crossing Locations",
    visible: false,
    expanded: false,
    children: {
      steel_rcl: {
        name: "Steel RCL",
        visible: false,
        wmsLayer: "haryanagas:steel_rcl",
      },
      mdpe_rcl: {
        name: "MDPE RCL",
        visible: false,
        wmsLayer: "haryanagas:mdpe_rcl",
      },
    },
  },

  ServiceConnections: {
    name: "Service Connections",
    visible: true,
    expanded: false,
    children: {
      tapoff: {
        name: "Tap-Off",
        visible: true,
        wmsLayer: "haryanagas:tapoff",
      },
    },
  },

  CustomerCommercialFacilities: {
    name: "Customer & Commercial Facilities",
    visible: false,
    expanded: false,
    children: {
      mrs: {
        name: "MRS",
        visible: false,
        wmsLayer: "haryanagas:mrs_industrial_commercial",
      },
      industrial_customer: {
        name: "Industrial Customer",
        visible: false,
        wmsLayer: "haryanagas:industrial",
      },
      commercial_customer: {
        name: "Commercial Customer",
        visible: false,
        wmsLayer: "haryanagas:commercial",
      },
      srn: {
        name: "SRM",
        visible: false,
        wmsLayer: "haryanagas:srn",
      },
    },
  },

  OtherUtilityFeatures: {
    name: "Other Utility Features",
    visible: false,
    expanded: false,
    children: {
      tf: {
        name: "TF",
        visible: false,
        wmsLayer: "haryanagas:tf",
      },
      tlp: {
        name: "TLP",
        visible: false,
        wmsLayer: "haryanagas:tlp",
      },
      tr: {
        name: "TR",
        visible: false,
        wmsLayer: "haryanagas:tr",
      },
      survey: {
        name: "Survey",
        visible: false,
        wmsLayer: "haryanagas:survey",
      },
    },
  },
};

export const createLayerGroups = () =>
  JSON.parse(JSON.stringify(DEFAULT_LAYER_GROUPS));

export default DEFAULT_LAYER_GROUPS;
